<template lang="pug">
	.creative-version-preview-list(v-if="showed && Version.SelectedVersion && Creative.SelectedCreative" v-window)
		.card
			.card-header
				i.fa.fa-edit
				span Creative Version Previews List
			.card-body.collapse.show
				.empty-previews(v-if="previews.length === 0") No previews created yet
				.existing-previews-header(v-if="previews.length > 0")
					.existing-preview
						.date Date
						.link Link
						.video
						.free-space
						.status-in-portfolio
						.settings-button
				.existing-previews-container(v-if="previews.length > 0")
					.existing-previews
						.existing-preview(v-for="preview in previews")
							.date {{preview.createDate.toLocaleString()}}
							.link
								a(:href="Preview.getPreviewUrl(preview)" target="_blank") {{preview['hash']}}
								span.preview-domain(v-if="Preview.getPreviewDomain(preview)")  ({{Preview.getPreviewDomain(preview)}})
							.video
								a(v-if="preview.options?.videoExist" :href="Preview.getPreviewVideoUrl(preview)" target="_blank") video link
							.free-space
							.status-in-portfolio
								.preview-icon(:class="{visible: preview['in_portfolio']}")
									i.fa.fa-map-o(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This preview displayed in the portfolio'}")
							.settings-button(v-if="Metadata.Config['feature-portfolio'] && Creative.SelectedCreative?.type === 'playable'" @click="previewSettings(preview)")
								i.fa.fa-cog
							.delete-button(v-else :class="{disabled: preview['in_portfolio']}" @click="deletePreview(preview, $event)")
								i.fa.fa-remove
				.form-actions
					button.btn.btn-primary(type="button" v-on:click="createNew()")
						i.fa.fa-plus
						span Create new preview
					button.btn.btn-link(type="button" v-on:click="openLatest()" :disabled="previews.length === 0")
						i.fa.fa-share
						span Open latest preview
					button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Creative } 			from './../../services/Creative';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';
	import { Preview } 			from './../../services/Preview';
	import { Metadata } 		from './../../services/Metadata';

	import _ 					from 'lodash';

	export default {
		name: "PreviewList",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Version Previews Changed",
				"Selected Version Preview Changed: [options.videoExist]",
				"Selected Version Preview Changed: [in_portfolio]",
				"Selected Version Preview Removed"
			],
			events: {

				"Show PreviewList": function() {

					this.update();

				}

			}
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;
			this.Preview = Preview;
			this.Metadata = Metadata;

			this.previews = [];

			return {
				showed: false
			}
		},
		methods: {
			collectData() {

				if (Preview.PreviewsByVersionByHash) {

					this.previews = _.orderBy(_.values(Preview.PreviewsByVersionByHash[Version.SelectedVersion?.id]) || [], 'createDate', 'desc');

				} else {

					this.previews = [];

				}

			},
			open(preview) {

				if (!preview) return;

				Broadcast.call("Preview Link Pressed");

				window.open(Preview.getPreviewUrl(preview), "_blank");

			},
			createNew() {

				if (Creative.SelectedCreative?.type === 'storyboard') {

					Broadcast.call("Show PreviewCreateStoryboard");

				} else {

					Broadcast.call("Show PreviewCreate");

				}

			},
			openLatest() {

				this.open(this.previews[0]);

			},
			previewSettings(preview) {

				Broadcast.call("Show Preview Settings", [preview]);

			},
			deletePreview(preview, e) {

				if (preview["in_portfolio"]) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete preview',
					message: `Are you sure you want to delete this preview?`,
					confirmButtonText: '&nbsp;&nbsp;Delete preview',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {

						Server.sendToSocket({
							DeletePreview: preview.id
						});

					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.creative-version-preview-list
		display: flex
		position: absolute
		z-index: 1000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 650px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-primary, .btn-outline-primary, .btn-link
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-link:hover
				color: var(--primary)

			.btn-dark
				float: right
				color: #fff

			.existing-previews-header
				display: table
				width: 100%
				height: 30px

				.existing-preview
					display: table-row

					.date
						display: table-cell
						width: 150px
						text-align: center

					.link
						display: table-cell
						width: 230px
						text-align: center

					.video
						display: table-cell
						width: 70px
						text-align: center

					.free-space
						display: table-cell

					.status-in-portfolio
						display: table-cell
						width: 30px
						text-align: center

					.settings-button
						display: table-cell
						text-align: center

					.delete-button
						display: table-cell
						text-align: center

			.existing-previews-container
				max-height: 200px
				border: 1px solid #23282c
				border-radius: 5px
				overflow-x: hidden
				overflow-y: auto

			.existing-previews
				display: table
				background-color: #343b41
				width: 100%

				.existing-preview
					display: table-row
					height: 30px
					padding: 0 1rem
					align-items: center
					justify-content: left
					color: var(--secondary)

					&:hover
						background-color: #4c4f54

					.date
						display: table-cell
						cursor: default
						width: 150px
						text-align: center
						vertical-align: middle

					.link
						display: table-cell
						width: 230px
						text-align: center
						vertical-align: middle
						white-space: nowrap

						a
							color: var(--secondary)

							&:hover
								color: var(--secondary)

						.preview-domain
							color: #8a939e
							font-size: 12px

					.video
						display: table-cell
						width: 70px
						text-align: center
						vertical-align: middle
						white-space: nowrap

						a
							color: var(--secondary)

							&:hover
								color: var(--secondary)

					.free-space
						display: table-cell

					.status-in-portfolio
						display: table-cell
						width: 30px
						font-size: 10px
						color: var(--primary)
						vertical-align: middle

						.preview-icon
							display: none

						.preview-icon.visible
							display: block

					.settings-button
						display: table-cell
						width: 30px
						margin-left: 10px
						font-size: 14px
						cursor: pointer
						text-align: center
						vertical-align: middle

						&:hover
							color: var(--blue)

					.delete-button
						display: table-cell
						width: 30px
						margin-left: 10px
						cursor: pointer
						font-size: 16px
						text-align: center
						vertical-align: middle

						&:hover
							color: #d16767

						&.disabled
							color: var(--secondary)
							cursor: default
							opacity: 0.2

				.existing-preview:first-child

					.date
						color: white

					.link

						a
							color: white

							&:hover
								color: white

					.video

						a
							color: white

							&:hover
								color: white

			.form-horizontal
				display: flex
				flex-direction: column

				.form-group
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center

			.form-actions
				margin-top: 1.25rem

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

</style>

